export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5505.6345120a.jpg";